import React from "react";
import { IoHomeOutline } from "react-icons/io5";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import BildirimContainer from "./BildirimContainer";
import { useSelector } from "react-redux";

const Bildirimler = ({ setRatingIsOpen }) => {
  const { notifications } = useSelector((state) => state.bildirim);

  return (
    <div className="relative containerMain min-h-[calc(100vh-80px)] flex flex-col gap-8">
      <div className="flex flex-col gap-8">
        <div className="baslik flex flex-col gap-4">
          <h1 className="text-2xl font-bold ">
            Tüm Bildirimler ({notifications?.length || 0})
          </h1>
          <div className="text-sm text-grayy flex items-center gap-2 font-medium">
            <IoHomeOutline className="w-4 h-4" />
            <Link to="/">Anasayfa</Link>
            <MdOutlineKeyboardArrowRight className="w-6 h-6" />
            <span className="text-darkerGreen">Tüm Bildirimler</span>
          </div>
        </div>
        <BildirimContainer setRatingIsOpen={setRatingIsOpen} />
      </div>
    </div>
  );
};

export default Bildirimler;
